<template>
  <div class="workbench-container">
    <HeaderCard />
    <div class="workbench">
      <div class="flex-container gap-10">
        <div class="flex-item-2">
          <EnterpriseWarRoom
            :agent-id="agentId"
            @open-detail="$emit('open-detail', $event)"
            @open-list="$emit('open-list')"
            @smart-analysis="$emit('smart-analysis', $event)"
            @start-chat="$emit('start-chat', $event)"
          />
        </div>
        <div class="flex-item">
          <TaskQueue
            :agent-id="agentId"
            @open-detail="(taskData) => $emit('task-open-detail', taskData)"
            @open-list="$emit('task-open-list')"
          />
        </div>
        <!-- <div class="flex-item">
          <PendingDecision
            @open-detail="$emit('decision-open-detail', $event)"
            @open-list="$emit('decision-open-list')"
            @smart-analysis="$emit('smart-analysis', $event)"
          />
        </div> -->
      </div>
      <div v-if="isCeoDemo" class="grid-container grid-1 gap-10">
        <BusinessIndicatorsYs @smart-analysis="$emit('smart-analysis', $event)" />
      </div>
      <div v-else class="grid-container grid-1 gap-10">
        <BusinessIndicators @smart-analysis="$emit('smart-analysis', $event)" />
      </div>
     <div v-if="!isCeoDemo" class="grid-container grid-1 gap-10">
        <BusinessChainAnalysis  @smart-analysis="$emit('smart-analysis', $event)" />
     </div>
     <div v-if="!isCeoDemo" class="grid-container grid-1-2 gap-10">
        <OperatingReport @open-tool="$emit('open-tool', $event)" />
       <!-- <CostAnalysis /> -->
        <Card1 />
       <!-- <KpiIndicators /> -->
      </div>
      <div v-else class="grid-container grid-3 gap-10">
        <!-- <OperatingReport v-if="!isCeoDemo" @open-tool="$emit('open-tool', $event)" /> -->
       <CostAnalysis />
        <!-- <Card1 v-if="!isCeoDemo" /> -->
       <KpiIndicators />
       <StrategyProgress />
      </div>
      <div v-if="isCeoDemo" class="grid-container grid-1 gap-10">
        <DigitalTwin />
      </div>
    </div>
  </div>
</template>

<script>
// // import WelcomeCard from '../components/WelcomeCard.vue'
// import AlertCard from '../components/AlertCard.vue'
// // import QuickActionCard from '../components/QuickActionCard.vue'
// import BusinessCard from '../components/BusinessCard.vue'
// import CostAnalysisCard from '../components/CostAnalysisCard.vue'
// import KPICard from '../components/KPICard.vue'
// import ReportCard from '../components/RevenueTrendCard.vue'
// import DepartmentCard from '../components/DepartmentProgressCard.vue'
import { AGENT_ID_MAP } from '@/store/modules/cosmoClaw'
import BusinessIndicators from '../components/businessIndicators.vue'
import BusinessChainAnalysis from '../components/BusinessChainAnalysis.vue'
import CostAnalysis from '../components/costAnalysis.vue'
import StrategyProgress from '../components/strategyProgress.vue'
import Card1 from '../components/card1.vue'
import OperatingReport from '../components/OperatingReport.vue'
import KpiIndicators from '../components/kpiIndicators.vue'
import DigitalTwin from '../components/digitalTwin.vue'
import EnterpriseWarRoom from '../components/EnterpriseWarRoom.vue'
import TaskQueue from '../components/TaskQueue.vue'
// import PendingDecision from '../components/PendingDecisions.vue'
import HeaderCard from '../components/HeaderCard.vue'
import BusinessIndicatorsYs from '../components/businessIndicatorsYs.vue'
import { mapState } from 'vuex'

export default {
  name: 'CeoWorkbench',
  components: {
    // // WelcomeCard,
    // AlertCard,
    // // QuickActionCard,
    // BusinessCard,
    // CostAnalysisCard,
    // KPICard,
    // ReportCard,
    // DepartmentCard,
    BusinessIndicatorsYs,
    StrategyProgress,
    BusinessIndicators,
    BusinessChainAnalysis,
    CostAnalysis,
    Card1,
    OperatingReport,
    KpiIndicators,
    DigitalTwin,
    EnterpriseWarRoom,
    TaskQueue,
    // PendingDecision,
    HeaderCard
  },
  data() {
    return {
      images: require('@/assets/imgs/workbench/ceo.png'),
      agentId: AGENT_ID_MAP.ceo_shu_zi_ren
    }
  },
  computed: {
    ...mapState('cosmoClaw', ['isCeoDemo'])
  },
  methods: {
    handleActionClick(item) {
      console.log('点击快捷操作:', item)
      this.$message.success(`打开${item.name}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.workbench-container {
  height: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
}
.workbench {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #fff transparent;
}
.workbench::-webkit-scrollbar {
  width: 4px;
}
.workbench::-webkit-scrollbar-track {
  background: transparent;
}
.workbench::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 2px;
}
.grid-container {
  width: 100%;
  min-width: 700px;
}
.grid-1 {
  display: grid;
  grid-template-columns: 1fr;
}
.grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.grid-1-2 {
  display: grid;
  grid-template-columns: 1fr 2fr;
}
.grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.flex-container {
  width: 100%;
  min-width: 700px;
  display: flex;
}
.flex-item {
  width: calc((100% - 10px) / 3);
  flex-shrink: 1;
  min-width: 0;
}
.flex-item-2 {
  width: calc((100% - 10px) / 3 * 2);
  flex-shrink: 1;
  min-width: 0;
}
.gap-10 {
  gap: 10px;
}
</style>
